// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';

htmx.config.globalViewTransitions = true;

class Accordion {
  constructor(domNode) {
    this.rootEl = domNode;
    this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

    const controlsId = this.buttonEl.getAttribute('aria-controls');
    this.contentEl = document.getElementById(controlsId);

    this.isOpen = this.buttonEl.getAttribute('aria-expanded') === 'true';

    if (this.isOpen) {
        this.contentEl.style.maxHeight = this.contentEl.scrollHeight + "px";
    }

    // add event listeners
    this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.isOpen);
  }

  toggle(open) {
    // don't do anything if the open state doesn't change
    if (open === this.isOpen) {
      return;
    }

    // update the internal state
    this.isOpen = open;

    // handle DOM updates
    this.buttonEl.setAttribute('aria-expanded', `${open}`);

    if (open) {
      this.contentEl.style.maxHeight = this.contentEl.scrollHeight + "px";
    } else {
      this.contentEl.style.maxHeight = null;
    }
  }

  // Add public open and close methods for convenience
  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}

document.addEventListener('DOMContentLoaded', function () {
    // init accordions
    const accordions = document.querySelectorAll('.accordion h3');
    accordions.forEach((accordionEl) => {
        const accord = new Accordion(accordionEl);
        
        if (accord.isOpen) {
        requestAnimationFrame(() => accord.open());
        }
    });
});

// Rellax 
import 'rellax/rellax';
let Rellax = require('rellax');
document.addEventListener('DOMContentLoaded', function() {
    let rellax = null;
  
    function initRellax() {
      if (window.innerWidth >= 1024) {
        if (!rellax) {
          rellax = new Rellax('.rellax', {
            // You can add other Rellax options here if needed
          });
        }
      } else {
        if (rellax) {
          rellax.destroy();
          rellax = null;
        }
      }
    }
  
    // Initialize on page load
    initRellax();
  
    // Re-initialize on window resize
    window.addEventListener('resize', initRellax);


});


jQuery(function($) {

    // Accordion Content
	$('.wp-block-icb-icb103-accordion-cta .accordion .toggle, .wp-block-icb-icb106-accordion .accordion .toggle, .wp-block-icb-icb110-accordion .accordion .toggle').on("click",function(e) {
        e.preventDefault();

        var $toggle = $(this);
        var $inner = $toggle.next('.accordion-inner');
        var $container = $toggle.parent();
        var $item = $toggle.parent();

        if( $item.hasClass('active') ) {

            $item.removeClass('active');
            //$inner.slideUp(350);
            //$item.find('.accordion-inner').slideUp(350);
            $inner.slideUp(350);

        } else {

            $item.addClass('active');
            //$inner.slideUp(350);
            //$item.find('.accordion-inner').slideDown(350);
            $inner.slideDown(350);

        }

        // if( $inner.hasClass('show') ) {

        //     $toggle.removeClass('active');
        //     $inner.removeClass('show').slideUp(350);

        // } else {

        //     $container.find('.toggle').removeClass('active');
        //     $container.find('li .accordion-inner').removeClass('show');
        //     $container.find('li .accordion-inner').slideUp(350);
        //     $inner.toggleClass('show');
        //     $inner.slideToggle(350);

        // }

    });

    // Accordion Content
	$('.wp-block-icb-icb105-income-limits .accordion .toggle').on("click",function(e) {
        e.preventDefault();

        var $toggle = $(this);
        var $inner = $toggle.next('.accordion-inner');
        var $item = $toggle.parent();

        if( $item.hasClass('active') ) {
            $item.removeClass('active');
            $inner.slideUp(350);
        } else {
            $item.addClass('active');
            $inner.slideDown(350);
        }

    });

    
    $('.wp-block-icb-icb105-income-limits .sub-accordion .sub-toggle').on("click",function(e) {
        e.preventDefault();

        var $toggle = $(this);
        var $inner = $toggle.next('.sub-accordion-inner');
        var $item = $toggle.parent();

        if( $item.hasClass('active') ) {
            $item.removeClass('active');
            $inner.slideUp(350);
        } else {
            $item.addClass('active');
            $inner.slideDown(350);
        }

    });

    // Income limits JS
    $('.wp-block-icb-icb105-income-limits .nav .section-link').on("click",function(e) {
        //e.preventDefault();

        var targetId = $(this).data('target');
        var accordion = $('#' + targetId);
        var inner = accordion.children('.accordion-inner');

        if( accordion.hasClass('active') ) {
            accordion.removeClass('active');
            inner.slideUp(350);
        } else {
            accordion.addClass('active');
            inner.slideDown(350);
        }

    });
    
});

document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('video-modal');
    const videoContainer = document.getElementById('video-container');
    const closeBtn = document.querySelector('.video-modal-close');
    // Only the modal-style play buttons (the lightbox <a> play buttons are
    // handled by featherlight/fslightbox and must not be hijacked here).
    const playButtons = document.querySelectorAll('.play-button[data-video]');

    // Bail out on pages without the video modal (e.g. anything but the video archive).
    if (!modal || !videoContainer || !closeBtn) return;

    // Track focus so it can be restored when the dialog closes (a11y).
    let lastFocusedEl = null;

    // Open video modal
    playButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const videoUrl = this.getAttribute('data-video');
            openVideoModal(videoUrl);
        });
    });

    // Close modal
    closeBtn.addEventListener('click', closeVideoModal);
    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            closeVideoModal();
        }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.style.display === 'block') {
            closeVideoModal();
        }
    });

    function openVideoModal(videoUrl) {
        if (!videoUrl) return;

        // Clear previous content
        videoContainer.innerHTML = '';

        // Determine video type and create appropriate element
        if (isYouTubeUrl(videoUrl)) {
            const embedUrl = getYouTubeEmbedUrl(videoUrl);
            videoContainer.innerHTML = `<iframe src="${embedUrl}" title="Video player" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
        } else if (isVimeoUrl(videoUrl)) {
            const embedUrl = getVimeoEmbedUrl(videoUrl);
            videoContainer.innerHTML = `<iframe src="${embedUrl}" title="Video player" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
        } else {
            // Direct video file
            videoContainer.innerHTML = `<video controls autoplay><source src="${videoUrl}" type="video/mp4">Your browser does not support the video tag.</video>`;
        }

        lastFocusedEl = document.activeElement;
        modal.style.display = 'block';
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        // Move focus into the dialog for keyboard/screen-reader users.
        closeBtn.focus();
    }

    function closeVideoModal() {
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        videoContainer.innerHTML = '';
        document.body.style.overflow = 'auto';
        // Return focus to the play button that opened the dialog.
        if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
            lastFocusedEl.focus();
            lastFocusedEl = null;
        }
    }

    function isYouTubeUrl(url) {
        return url.includes('youtube.com') || url.includes('youtu.be');
    }

    function isVimeoUrl(url) {
        return url.includes('vimeo.com');
    }

    function getYouTubeEmbedUrl(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        const videoId = (match && match[2].length === 11) ? match[2] : null;
        return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : url;
    }

    function getVimeoEmbedUrl(url) {
        const regExp = /vimeo.*\/(\d+)/i;
        const match = url.match(regExp);
        const videoId = match ? match[1] : null;
        return videoId ? `https://player.vimeo.com/video/${videoId}?autoplay=1` : url;
    }

    // Lazy loading for video thumbnails
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                    imageObserver.unobserve(img);
                }
            });
        });

        const lazyImages = document.querySelectorAll('img[data-src]');
        lazyImages.forEach(img => imageObserver.observe(img));
    }
});

/*
 * GTranslate landmark fix (a11y / 508).
 * The GTranslate plugin injects its floating language switcher as a bare <div>
 * directly under <body>, so its controls sit outside every landmark region and
 * are unlabeled. Promote the wrapper to a labeled navigation landmark so the
 * language switcher is reachable and announced as "Language" navigation.
 */
document.addEventListener('DOMContentLoaded', function() {
    const gt = document.querySelector('.gtranslate_wrapper, [id^="gt-wrapper"], #gt_float_wrapper');
    if (!gt) return;
    if (!gt.getAttribute('role')) {
        gt.setAttribute('role', 'navigation');
    }
    if (!gt.getAttribute('aria-label')) {
        gt.setAttribute('aria-label', 'Language');
    }
});